export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13903.7cf3848b.jpg";